import React, { useRef, useState,useContext,useEffect } from 'react';
import { 
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, 
  Typography, Button, Box, Grid, Container,Snackbar,Alert,Modal
} from '@mui/material';
import { useReactToPrint } from 'react-to-print';
import AppContext from '../AppContext';
import { getDoc, doc } from 'firebase/firestore';
import { db } from '../firebase'; // Adjust the import based on your Firebase setup
import { format, isValid } from "date-fns";

const SaleSummaryPrint = ({ saleDetails, onClose, shopInfo }) => {
  const componentRef = useRef();
  //eslint-disable-next-line
  const [isPrinting, setIsPrinting] = useState(false);
  const { shopId, t } = useContext(AppContext);  
  const [shopData, setShopData] = useState({
    shopLogo: '',
    shopName: '',
    shopAddress: '',
    phoneNumber: '',
  });
  //eslint-disable-next-line
  const [loading,setLoading]=useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handlePrint = useReactToPrint({
    content: () => {
      try {
        return componentRef.current;
      } catch (error) {
        setErrorMessage("Error fetching content for printing.");
        setOpenSnackbar(true);
        return null;
      }
    },
    onBeforeGetContent: () => {
      try {
        setIsPrinting(true);
      } catch (error) {
        setErrorMessage("Error before getting content.");
        setOpenSnackbar(true);
      }
    },
    onAfterPrint: () => {
      try {
        setIsPrinting(false);
      } catch (error) {
        setErrorMessage("Error after printing.");
        setOpenSnackbar(true);
      }
    }
  });
  

  useEffect(() => {
    if (shopId) {
      setLoading(true);
      try{
        fetchShopData(shopId);
      }
      catch(error)
      {
        console.log(error);
      }
      finally{
        setLoading(false);
      }
      
    }
  },[shopId]);

  const fetchShopData = async (id) => {
    const docRef = doc(db, 'shops', id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      setShopData(docSnap.data());
    } else {
      console.log('No such document!');
    }
  };

  const formatToMyanmarCurrency = (number) => {
    const formattedNumber = new Intl.NumberFormat('my-MM').format(number);
    return `${formattedNumber}`;
  };
  
  const printStyles = `
  @media print {
    @page {
      size: 80mm auto;
      margin: 0 !important;
      padding: 0 !important;
    }
    body {
      width: 80mm;
      margin: 0 !important;
      padding: 0 !important;
      line-height: 1.2;
    }
    .print-container {
        width: 100%;
        font-size: 12px !important; /* Base font size for print */
        min-height: unset; /* Remove any minimum height constraints */
        height: auto; /* Let height be determined by content */
        break-inside: avoid; /* Prevent page breaks within the container */
        margin: 0 !important; /* Remove margin */
        padding: 0 !important; /* Remove padding */
    }
    h3 { font-size: 20px !important; margin: 4px 0; }
    h4 { font-size: 14px !important; margin: 4px 0; }
    img { max-width: 60px; height: auto; }
    .MuiTypography-root { font-size: 12px; }
    .MuiTableCell-root { font-size: 12px;padding: 2px 8px !important; }
    .MuiGrid-item { font-size: 12px;padding: 2px !important; }
  }
  
    `;

  return (
    <Container>
    <Box ref={componentRef} className="print-container">
      <style>{printStyles}</style>
      <Box textAlign="center" mb={2}>
      {shopData.shopLogo && (
          <img 
            src={shopData.shopLogo} 
            alt="Shop Logo" 
            sx={{ maxWidth: '100px', marginBottom: '10px', marginTop: '10px' }} 
          />
        )}
        <Typography variant="h3">{shopData.shopName}</Typography>
        <Typography>{shopData.shopAddress}</Typography>
        <Typography>{shopData.phoneNumber}</Typography>
        <Typography sx={{ borderBottom: '1px dashed', width: '100%', my: 1 }}></Typography>
      
        <Typography variant="h5">#{saleDetails.orderId}</Typography>
        <Typography>
          {saleDetails.orderDate && (
            saleDetails.orderDate instanceof Date 
              ? format(saleDetails.orderDate, "dd-MM-yyyy hh:mm a")
              : saleDetails.orderDate.toDate 
              ? format(saleDetails.orderDate.toDate(), "dd-MM-yyyy hh:mm a")
              : "Invalid date"
          )}
        </Typography>

        <TableContainer sx={{ mt: 2 }}>
        <Table size="small"> {/* Reduce row height */}
            <TableBody>
            {saleDetails.cartItems.map((item, index) => (
                <React.Fragment key={index}>
                <TableRow sx={{ height: 'unset' }}> {/* Remove extra height */}
                    <TableCell sx={{ border: 'none', padding: '0px 16px' }}>
                    {item.name}
                    </TableCell>
                    <TableCell sx={{ border: 'none', padding: '0px 16px', textAlign: 'right' }}>
                    {formatToMyanmarCurrency(item.totalPrice)}
                    </TableCell>
                </TableRow>
                <TableRow sx={{ height: 'unset' }}> {/* Remove extra height */}
                    <TableCell sx={{ border: 'none', padding: '0px 16px' }}>
                    {item.quantity} Units x {formatToMyanmarCurrency(item.price + item.variantPrice)}
                    </TableCell>
                    <TableCell sx={{ border: 'none', padding: '0px' }}></TableCell>
                </TableRow>
                </React.Fragment>
            ))}
            </TableBody>
        </Table>
        </TableContainer>

      <Grid container spacing={1} mt={1}>
        <Grid item xs={9} align="right">
        <Typography>သင့်ငွေ</Typography>
        </Grid>
        <Grid item xs={3} align="right">
        <Typography sx={{marginRight:'16px'}}>{formatToMyanmarCurrency(saleDetails?.subtotal || 0)}</Typography>
        </Grid>
        {/** 
        <Grid item xs={9} align="right">
        <Typography>စားသုံးခွန်</Typography>
        </Grid>
        <Grid item xs={3} align="right">
        <Typography  sx={{marginRight:'16px'}}>{formatToMyanmarCurrency(saleDetails?.tax || 0)}</Typography>
        </Grid>
          */}
        <Grid item xs={9} align="right">
        <Typography>စုစုပေါင်း</Typography>
        </Grid>
        <Grid item xs={3} align="right">
        <Typography sx={{marginRight:'16px'}}>{formatToMyanmarCurrency(saleDetails?.amount || 0)}</Typography>
        </Grid>
        <Grid item xs={9} align="right">
        <Typography>{`ပေးငွေ (${saleDetails?.paymentMethod})`}</Typography>
        </Grid>
        <Grid item xs={3} align="right">
        <Typography sx={{marginRight:'16px'}}>{formatToMyanmarCurrency(saleDetails?.paymentAmount || 0)}</Typography>
        </Grid>
    </Grid>
    </Box>
      {/*
      <Typography gutterBottom mt={3} ml={2}>{t("Remark")}</Typography>
      <Typography ml={2}>{saleDetails.customerNotes}</Typography>   
        */}     
    </Box>
    <Box mt={3} display="flex" justifyContent="space-between">
    <Button variant="contained" color="primary" onClick={handlePrint}>
      Print Receipt
    </Button>
    <Button variant="outlined" onClick={onClose}>
      Close
    </Button>
  </Box>
  
  </Container>
  );
};

export default SaleSummaryPrint;
